import { render, staticRenderFns } from "./AddSupplierEvalModal.vue?vue&type=template&id=4ece9964&scoped=true&"
import script from "./AddSupplierEvalModal.vue?vue&type=script&lang=js&"
export * from "./AddSupplierEvalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece9964",
  null
  
)

export default component.exports